import checkout from "./form";

const {
  formField: {
    sellerName,
    sellerTaxCode,
    sellerPhone,
    sellerAddress,
    sellerBankAccount,
    buyerName,
    buyerTaxCode,
    buyerAddress,
    buyerBankAccount,
    day,
    payments,
    currency,
    invoiceSymbol,
    number,
    status,
  },
} = checkout;

const initialValues = {
  [sellerName.name]: "",
  [sellerTaxCode.name]: "",
  [sellerPhone.name]: "",
  [sellerAddress.name]: "",
  [sellerBankAccount.name]: "",
  [buyerName.name]: "",
  [buyerTaxCode.name]: "",
  [buyerAddress.name]: "",
  [buyerBankAccount.name]: "",
  [day.name]: "",
  [payments.name]: "",
  [currency.name]: "",
  [invoiceSymbol.name]: "",
  [number.name]: "",
  [status.name]: "",
};

export default initialValues;
